(() => {
  "use strict";
  let e = {
      onLoad() {
        let { container: e } = this;
        try {
          AT.detectVisible({
            element: e,
            rootMargin: "0px",
            callback: () => {
              e.querySelector("slider-component").init();
            },
          });
        } catch (t) {
          console.log(e), console.error(t);
        }
      },
    },
    t = (e, t, n) => {
      let i = {};
      if (!e) return;
      //console.log(t);
      let r = e.dataset.statusSoldOut,
        a = e.getElementsByClassName("js-option-item");

      function o(t) {
        let n,
          a,
          o = s();
        switch (t) {
          case 1:
            (n = "root"),
              (a = e.querySelector(".js-swatch-item[data-position='1']"));
            break;
          case 2:
            (n = o.option1),
              (a = e.querySelector(".js-swatch-item[data-position='2']"));
            break;
          case 3:
            (n = o.option1 + " / " + o.option2),
              (a = e.querySelector(".js-swatch-item[data-position='3']"));
        }
        switch (a.dataset.style) {
          case "select": {
            let e = a.getElementsByClassName("js-option-item")[0],
              t = e.value;
            switch (r) {
              case "hide":
                (e.innerHTML = i[n]
                  .map((e) => `<option value="${e}">${e}</option>`)
                  .join("")),
                  i[n].includes(t) && (e.value = t);
                break;
              case "disable":
                [...e.options].forEach((e) => {
                  i[n].includes(e.value)
                    ? (e.disabled = !1)
                    : ((e.disabled = !0), (e.selected = !1));
                }),
                  [...e.options].find(
                    (e) => 0 == e.disabled && (e.selected = !0)
                  );
            }
            break;
          }
          case "color":
          case "image":
          case "button":
            let e = a.getElementsByClassName("js-option-item"),
              t = [...e].find((e) => e.checked).value;
            switch (r) {
              case "hide":
                e.forEach((r) => {
                  i[n].includes(r.value)
                    ? r.closest(".swatch-group_wrapper").removeClass("d-none")
                    : (r.closest(".swatch-group_wrapper").addClass("d-none"),
                      t === r.value && ((r.checked = !1), (e[0].checked = !0)));
                });
                break;
              case "disable":
                e.forEach((r) => {
                  i[n].includes(r.value)
                    ? (r.disabled = !1)
                    : ((r.disabled = !0),
                      t === r.value && ((r.checked = !1), (e[0].checked = !0)));
                });
            }
        }
        e.dispatchEvent(
          new CustomEvent("swatch-change", {
            detail: { position: t, optionValue: o[`option${t}`] },
          })
        );
      }
      function s() {
        return [...e.getElementsByClassName("js-swatch-item")].reduce(
          (e, t) => {
            switch (t.dataset.style) {
              case "select":
                let n = t.querySelector("select.single-option-selector");
                e[n.name] = n.value;
                break;
              case "color":
              case "image":
              case "button":
                let i = t.querySelectorAll(
                  "input[data-single-option-selector]"
                );
                e[i[0].name] = [...i].find((e) => e.checked).value;
            }
            return e;
          },
          {}
        );
      }

      function c(e) {
        return t.variants.find((t) =>
          Object.keys(e).every((n) => t[n] === e[n])
        );
      }
      t.variants.length < 2 ||
        (a.addEvents("change", function () {
          e.dispatchEvent(
            new CustomEvent("swatch-change", {
              detail: {
                position: +this.dataset.optionPosition,
                optionValue: this.value,
              },
            })
          );
        }),
        e.addEvent(
          "swatch-change",
          function ({ detail: { position: i, optionValue: r } }) {
            switch (
              ((e.querySelector(
                `[data-selected-option='option${i}']`
              ).innerHTML = r),
              i)
            ) {
              case 1:
                t.options.length > 1 ? o(2) : n(c(s()));
                break;
              case 2:
                3 === t.options.length ? o(3) : n(c(s()));
                break;
              case 3:
                n(c(s()));
            }
          }
        ),
        t.variants.forEach((e) => {
          if (e.available) {
            if (
              ((i.root = i.root || []),
              i.root.push(e.option1),
              (i.root = i.root.reduce(
                (e, t) => (e.includes(t) || e.push(t), e),
                []
              )),
              t.options.length > 1)
            ) {
              var n = e.option1;
              (i[n] = i[n] || []),
                i[n].push(e.option2),
                (i[n] = i[n].reduce(
                  (e, t) => (e.includes(t) || e.push(t), e),
                  []
                ));
            }
            if (3 === t.options.length) {
              n = e.option1 + " / " + e.option2;
              (i[n] = i[n] || []),
                i[n].push(e.option3),
                (i[n] = i[n].reduce(
                  (e, t) => (e.includes(t) || e.push(t), e),
                  []
                ));
            }
          }
        }),
        o(1));
    };
  HTMLElement;
  HTMLElement;
  HTMLElement;
  HTMLElement;
  HTMLElement;
  HTMLElement;
  let n = {
    onLoad: function () {
      let e = this.container;
      if (
        ((this.product = theme.product),
        (this.elms = {
          priceCompareElement: e.querySelector(".js-price-compare"),
          priceElement: e.querySelector(".js-price"),
          wascomparePriceWrapper: e.querySelector('.js-wascomparePrice'),
          priceCompareDiscountWrapperElement: e.querySelector(".js-compare-discount-wrapper"),
          priceCompareDiscountElement: e.querySelector(".js-compare-discount"),
          priceCompareDiscountPercentElement: e.querySelector(".js-compare-discount-percent"),
          skuElement: e.querySelector(".js-sku"),
          inventoryElement: e.querySelector(".js-inventory"),
          mediaMain: document.getElementById("product-media-main"),
          mediaThumnails: document.getElementById("product-media-thumnails"),
          selectMaster: e.querySelector("#select-master"),
          addToCartButton: e.querySelector(".js-atc-btn"),
          formElement: e.querySelector("form[action*='/cart/add']"),
          labelSaveContainer: e.querySelector(".js-product-label-save"),
          swatchContainer: e.querySelector("swatch-component"),
          findStoreButton: e.querySelector(".js-find-store-btn"),
          quantityInputContainer: e.querySelector(".js-product-quantity"),
          subscribeForm: e.querySelector("#contact-notify-when-available"),
          dynamicCheckoutContainer: e.querySelector(
            ".js-product-dymanic-checkout"
          ),
          dynamicCheckoutContainerWrapper: e.querySelector(
            ".js-product-dymanic-checkout-wrapper"
          ),
        }),
        (this.conditions = {
          cond_1p_is_onetime : window.global_conditions.checkCondLogics(this.product.id, "cond_1p", "is-onetime"),
          cond_1p_is_purchased : window.global_conditions.checkCondLogics(this.product.id, "cond_1p", "is-purchased"),
        }),
        (this.settings = JSON.parse(
          this.container.querySelector("[data-settings]").innerHTML
        )),
        document.querySelector(".shipping-time") &&
          (this.initOrderDeadLine(), this.initOrderShipping()),
        document.querySelector("#bundledAddToCart") &&
          (this.initProductItemEvents(), this.initMultiVariantEvents()),
        this.initSliderMedia(),
        this.initInventory(),
        this.initFormAddToCart(),
        t(
          this.elms.swatchContainer,
          this.product,
          this.handleVariantChange.bind(this)
        ),
        //this.updatePrice(theme.init_selected_variant),
        //this.initScrollToReviews(),
        AT.getParameterByName("contact_posted"))
      ) {
        this.switchVariantById(AT.cookie.get("subscribe-variant-id")),
          AT.cookie.delete("subscribe-variant-id");
        let e = window.location.search
          .replace("?", "")
          .split("&")
          .filter((e) => !e.includes("contact_posted"))
          .filter(Boolean)
          .join("&");
        window.history.replaceState({}, "", `${window.location.pathname}?${e}`);
      }
    },
    initProductItemEvents() {
      document.querySelectorAll(".js-input-quantity");
      this.initAddToCartFormEvent();
    },
    initAddToCartFormEvent(e) {
      let t = document.querySelector(".js-bundledAddToCart"),
        n = t.querySelector(".js-btn-add-to-cart");
      t.addEvent("submit", (e) => {
        e.preventDefault();
        let i = [...t.querySelectorAll("input[name='quantity']")].reduce(
          (e, t) => (
            +t.value > 0 &&
              e.push({ id: +t.dataset.variantId, quantity: +t.value }),
            e
          ),
          []
        );
        i.length &&
          (n.hasClass("has-pending") ||
            n.insertAdjacentHTML(
              "beforeend",
              '<svg class="svg-loading" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; shape-rendering: auto;" width="28px" height="28px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><circle cx="50" cy="50" fill="none" stroke="var(--main-color)" stroke-width="5" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">  <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform></circle></svg>'
            ),
          n.addClass("pending", "has-pending"),
          Cart.addMutiple(i)
            .then((e) => {})
            .finally(() => {
              n.removeClass("pending"), (window.location.href = "/cart");
            }));
      });
    },
    initMultiVariantEvents() {
      let e = document.querySelectorAll(".select-master-bundle"),
        t = document.querySelectorAll(".bundled-checkbox"),
        n = document.querySelector(".js-bundled-total-price"),
        i = Number(
          document
            .querySelector(".bundled-total-price")
            .getAttribute("data-bundled-total-price")
        );
      t.forEach(function (e) {
        e.addEventListener("change", function () {
          let e = this.closest(".bundled-item"),
            t = this.getAttribute("data-id"),
            r = Number(this.getAttribute("data-price"));
          this.checked
            ? ((i += r),
              (e.querySelector(".js-input-quantity").value = "1"),
              document.querySelector("#" + t).removeClass("d-none"),
              e
                .querySelector(".select-group-bundle")
                .hasClass("select-multi-variants") &&
                e.querySelector(".select-group-bundle").removeClass("d-none"))
            : ((i -= r),
              (e.querySelector(".js-input-quantity").value = "0"),
              document.querySelector("#" + t).addClass("d-none"),
              e
                .querySelector(".select-group-bundle")
                .hasClass("select-multi-variants") &&
                e.querySelector(".select-group-bundle").addClass("d-none")),
            (n.innerHTML = i.toCurrency()),
            document
              .querySelector(".bundled-total-price")
              .setAttribute("data-bundled-total-price", i),
            (i = Number(
              document
                .querySelector(".bundled-total-price")
                .getAttribute("data-bundled-total-price")
            ));
        });
      }),
        e.forEach(function (e) {
          e.addEventListener("change", function () {
            let e = this.getAttribute("id"),
              t = this.closest(".bundled-item"),
              r = Number(
                this.options[this.selectedIndex].getAttribute(
                  "data-option-price"
                )
              );
            Number(
              t.querySelector(".bundled-checkbox").setAttribute("data-price", r)
            );
            t
              .querySelector(".js-input-quantity")
              .setAttribute("id", this.value),
              t
                .querySelector(".js-input-quantity")
                .setAttribute("data-variant-id", this.value),
              (document.querySelector("." + e).innerHTML = r.toCurrency());
            let a = 0;
            document
              .querySelectorAll(".bundled-checkbox")
              .forEach(function (e) {
                if (e.checked) {
                  let t = Number(e.getAttribute("data-price"));
                  a += t;
                }
              }),
              (n.innerHTML = a.toCurrency()),
              document
                .querySelector(".bundled-total-price")
                .setAttribute("data-bundled-total-price", a),
              (i = Number(
                document
                  .querySelector(".bundled-total-price")
                  .getAttribute("data-bundled-total-price")
              ));
          });
        });
    },
    initOrderDeadLine() {
      let e = parseInt(
          document.querySelector(".shipping-time").getAttribute("data-deadline")
        ),
        t = document.querySelector(".deadline"),
        n = new Date(),
        i = new Date(n.getFullYear(), n.getMonth(), n.getDate());
      i.setHours(e),
        (t.innerHTML =
          n >= i
            ? "Order until <strong>" + e + ":00 tomorrow</strong>"
            : "Order today until <strong>" + e + ":00</strong>");
    },
    initOrderShipping() {
      let e = new Date(),
        t = e,
        n = parseInt(
          document
            .querySelector(".shipping-time")
            .getAttribute("data-deliverytime")
        );
      for (let i = 1; i <= n; i++)
        t = new Date(e.getTime() + 24 * i * 60 * 60 * 1e3);
      let i = new Array(7);
      (i[0] = "Sunday"),
        (i[1] = "Monday"),
        (i[2] = "Tuesday"),
        (i[3] = "Wednesday"),
        (i[4] = "Thurday"),
        (i[5] = "Friday"),
        (i[6] = "Saturday");
      let r = i[t.getDay()],
        a = new Array();
      (a[0] = "January"),
        (a[1] = "February"),
        (a[2] = "March "),
        (a[3] = "April"),
        (a[4] = "May"),
        (a[5] = "June"),
        (a[6] = "July"),
        (a[7] = "August"),
        (a[8] = "September"),
        (a[9] = "October"),
        (a[10] = "November"),
        (a[11] = "December");
      let o = a[t.getMonth()];
      document.querySelector(".dt-time").innerHTML =
        r + ",&nbsp;" + t.getDate() + "&nbsp;" + o;
    },
    initSliderMedia: function () {
      let { mediaMain: e, mediaThumnails: t } = this.elms;
      (this.mainSlider = e.init({ gutter: 12 })), t.init();
    },
    handleVariantChange: function (e) {
      let { skuElement: t, selectMaster: n, mediaMain: i } = this.elms;
      if (!e)
        return this.updateVariantStatus(), void i.addClass("product-sold-out");
      (this.currentVariant = e),
        this.updateLabelSave(e),
        this.updateVariantStatus(e),
        this.updatePrice(e),
        this.updateURLHash(e),
        e.available
          ? i.removeClass("product-sold-out")
          : i.addClass("product-sold-out"),
        e.sku
          ? (t.innerHTML = e.sku)
          : (t.innerHTML = theme.strings.product.skuNA),
        e.featured_media && this.mainSlider.goTo(e.featured_media.position - 1),
        (n.value = e.id);
    },
    initInventory() {
      let { inventoryElement: e } = this.elms;
      this.inventory = {
        setStatus: (t, n) => {
          if (this.settings.showInventory)
            switch ((e.setAttribute("data-status", t), t)) {
              // case "coming-stock":
              //   e.querySelector(".inventory_coming-stock").innerHTML =
              //     theme.strings.dateComingStock.replace(
              //       "{{date}}",
              //       n.next_incoming_date
              //     );
              //   break;
              case "low-stock":
                n.inventory_quantity < 6 ?
                e.querySelector(".inventory_low-stock").innerHTML = theme.strings.product.customLowStock
                :
                document.querySelector('.quant_btn').style.display = 'none';
                //   n.inventory_quantity > 1
                //     ? theme.strings.product.customLowStock
                //     : theme.strings.product.customLowStock
                // )
                // .replace("{{quantity}}", n.inventory_quantity);
                break;
              // case "items-stock":
                // e.querySelector(".inventory_items-stock").innerHTML = (
                //   n.inventory_quantity > 1
                //     ? theme.strings.product.itemsStock
                //     : theme.strings.product.itemStock
                // ).replace("{{quantity}}", n.inventory_quantity);
            }
        },
      };
    },
    updateVariantStatus(e) {
      let { addToCartButton: t } = this.elms;
      e
        ? (this.settings.enableSubscribe &&
            (this.updateDynamicCheckout(e.available),
            this.updateSubscribeForm(e)),
          this.updateAddToCartButton(e),
          this.updateInventory(e))
        : ((t.disabled = !0),
          (t.querySelector("span").innerHTML =
            theme.strings.product.unavailable),
          document.querySelector(".shipping-time").addClass("d-none"),
          this.inventory.setStatus("out-stock"));
    },
    updateDynamicCheckout(e) {
      let { dynamicCheckoutContainer: t } = this.elms;
      t && (e ? t.removeClass("d-none") : t.addClass("d-none"));
    },
    updateSubscribeForm(e) {
      let { subscribeForm: t } = this.elms,
        { dynamicCheckoutContainerWrapper: td } = this.elms,
        n = t.querySelector("input[name='contact[body]']"),
        i = t.querySelector(".js-product-subscribe");
      !AT.getParameterByName("contact_posted") &&
        i.removeClass("posted-successfully"),
        (n.value = n.dataset.value.replace("{{product_name}}", e.name)),
        e.available ? i.addClass("d-none") : i.removeClass("d-none"),
        e.available ? document.querySelector('.input-group.qnt_group').classList.add("stikcy_add") : document.querySelector('.input-group.qnt_group').classList.remove("stikcy_add"),
        e.available ? td.removeClass("float-product-subscribe") : td.addClass("float-product-subscribe"),
        t.addEvent("submit", () => {
          AT.cookie.set("subscribe-variant-id", this.currentVariant.id);
        });
    },
    updateAddToCartButton(e) {
      let { addToCartButton: t, quantityInputContainer: n } = this.elms;
      window.global_conditions.validateCartLogics(t);

      e.available ? ((t.disabled = !1),
      (t.querySelector("span").innerHTML =
        0 == e.inventory_quantity && "continue" == e.inventory_policy
          ? theme.strings.product.preorder
           : theme.strings.product.addToCart),
          this.settings.enableSubscribe && document
              .querySelector(".product-form_dynamic-checkout").removeClass("d-none") && n.removeClass("d-none"),
          document.querySelector(".product-wishlist-compare") &&
            document
              .querySelector(".product-wishlist-compare")
              .removeClass("d-none"),
          document.querySelector(".people-in-cart") &&
            document.querySelector(".people-in-cart").removeClass("d-none"),
          document.querySelector(".shipping-time") &&
            document.querySelector(".shipping-time").removeClass("d-none"),
          document.querySelector(".product-countdown-detail") &&
            document
              .querySelector(".product-countdown-detail")
              .removeClass("d-none"))
        : ((t.disabled = !0),
          (t.querySelector("span").innerHTML = theme.strings.product.soldOut),
          this.settings.enableSubscribe &&
          document
              .querySelector(".product-form_dynamic-checkout").addClass("d-none"),
          document.querySelector(".product-wishlist-compare") &&
            document
              .querySelector(".product-wishlist-compare")
              .addClass("d-none"),
          document.querySelector(".people-in-cart") &&
            document.querySelector(".people-in-cart").addClass("d-none"),
          document.querySelector(".shipping-time") &&
            document.querySelector(".shipping-time").addClass("d-none"),
          document.querySelector(".product-countdown-detail") &&
            document
              .querySelector(".product-countdown-detail")
              .addClass("d-none"));
    },
    updateInventory(e) {
      e.available
        ? e.inventory_management
          ? 0 == e.inventory_quantity && e.incoming
            ? this.inventory.setStatus("coming-stock", e)
            : e.inventory_quantity <= this.settings.inventoryThreshold
            ? this.inventory.setStatus("low-stock", e)
            : this.inventory.setStatus("items-stock", e)
          : this.inventory.setStatus("in-stock")
        : this.inventory.setStatus("out-stock");
    },
    initFormAddToCart() {
      let { formElement: e, addToCartButton: t } = this.elms;
      window.global_conditions.validateCartLogics(t);
      e.addEvent("submit", (n) => {
        n.preventDefault(),
          t.hasClass("has-pending") ||
            t.insertAdjacentHTML(
              "beforeend",
              '<svg class="svg-loading" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; shape-rendering: auto;" width="28px" height="28px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><circle cx="50" cy="50" fill="none" stroke="var(--main-color)" stroke-width="5" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">  <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform></circle></svg>'
            ),
          t.addClass("pending", "has-pending"),
          Cart.add(e)
            .then ( () => {
              window.global_conditions.validateCartLogics(t);
            })
            .catch((e) => {
              AT.loadPopupMessage().then(() => {
                Popups.closeAll(), PopupMessage.open(e.description);
              });
            })
            .finally(() => {
              t.removeClass("pending");
            });
      });
    },
    initScrollToReviews() {
      let e = document.querySelector("#product-reviews-widget");
      document
        .querySelector("#product-review-badge")
        .addEvent("click", () => AT.scrollTo(e, 1e3, e.click()));
    },
    updateLabelSave(e) {
      let { labelSaveContainer: t } = this.elms,
        n = t.querySelector(".js-percent"),
        i = t.querySelector(".js-money-saved"),
        { compare_at_price: r, price: a } = e;
      r > a
        ? ((i.innerHTML = (r - a).toCurrency()),
          (n.innerHTML = Math.round(((r - a) / r) * 100)),
          t.removeClass("d-none"))
        : t.addClass("d-none");
    },

    updatePrice(e) {
      let { priceCompareElement: t,
        priceElement: n,
        priceCompareDiscountElement: m,
        priceCompareDiscountPercentElement: o,
        priceCompareDiscountWrapperElement: p,
        wascomparePriceWrapper: z } = this.elms;
      e.compare_at_price
        ? ((t.innerHTML = e.compare_at_price.toCurrency()),
          z.removeClass("d-none"),
          p.removeClass("d-none"))
        : (p.addClass("d-none"),
          z.addClass("d-none")),
        (n.innerHTML = e.price.toCurrency(),
        m.innerHTML = (e.compare_at_price - e.price).toCurrency(),
        o.innerHTML = Math.ceil((e.compare_at_price - e.price)*100/e.compare_at_price)).toString,
        o.insertAdjacentHTML('beforeend', "%");
    },
    updateURLHash(e) {
      let t = window.location.search
        .replace("?", "")
        .split("&")
        .filter(Boolean);
      window.history.replaceState(
        {},
        "",
        AT.getParameterByName("variant")
          ? `${window.location.pathname}?${t
              .map((t) => (t.includes("variant") ? "variant=" + e.id : t))
              .join("&")}`
          : (t.unshift("variant=" + e.id),
            `${window.location.pathname}?${t.join("&")}`)
      );
    },
    switchVariantById(e) {
      let { swatchContainer: t } = this.elms,
        n = theme.product.variants.find((t) => t.id == e);
      n &&
        n.options.forEach((e, n) => {
          [...t.querySelectorAll(`[name='option${n + 1}']`)].find((t) => {
            switch (t.tagName) {
              case "INPUT":
                t.value == e &&
                  ((t.checked = !0), t.dispatchEvent(new Event("change")));
                break;
              case "SELECT":
                (t.value = e), t.dispatchEvent(new Event("change"));
            }
          });
        });
    },
  };
// mobile view description tab
    if (window.innerWidth > 769) {
                $(document).ready(function(){
                    document.querySelector('.tab-item.js-tab-content').classList.add('active');
                    document.querySelectorAll('.nav-item.js-tab-control')[0].classList.add('active');
                })
    }
    if (window.innerWidth < 769) {
            $(".pdViewTab-close-mobile").on('click', function(event){
                event.stopPropagation();
                event.stopImmediatePropagation();
                var boxes = document.querySelectorAll('.tab-item.js-tab-content');
                boxes.forEach(box => {
                box.classList.remove('active');
                });
            });
    }
  theme.sectionRegister.forEach((t) => {
    switch (t) {
      case "product-template":
        register(t, n);
        break;
      case "related-products":
        register(t, e);
    }
  }),
    load("*"),
    console.log("product-page.js loaded");
})();
function full_details(){
    document.querySelector('.tab-contents.js-tab-contents').classList.toggle('hidden-on-phone');
    var btn_text = document.querySelector('.btn_full_details');
    if (btn_text.innerText === "View full details") {
        btn_text.innerText = "View Less";
      } else {
        btn_text.innerText = "View full details";
      }
}
